<template>
    <div v-if="pembelian">
        <b-card class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">{{ isPembayaran ? '' : (isKonfirmasi ? 'Konfirmasi' : 'Informasi') }} Pembayaran Supplier</h5>
            </b-card-header>
            <b-card-body v-show="isKonfirmasi">
                <p>Pembayaran sebesar Rp. {{ pembayaran.harga_per_kg ? formatNumber(totalPembayaran) : '-' }} kepada {{ pembelian.supplier ? pembelian.supplier.name : '-' }}.</p>
                <p>Dengan metode pembayaran {{ pembayaran.metode && pembayaran.metode.name ? pembayaran.metode.name.toUpperCase() : (metode && metode.name ? metode.name.toUpperCase() : '-') }}.</p>
            </b-card-body>
            <b-card-body v-show="!isKonfirmasi">
                <div class="table-responsive">
                    <table class="table table-borderless">
                        <tr>
                            <th class="fit-column">Supplier</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ pembelian.supplier ? pembelian.supplier.name : '-' }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Tanggal</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatDate(pembelian.created_at) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Grader</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ pembelian.grader ? pembelian.grader.name : '-' }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Gudang</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ pembelian.gudang ? pembelian.gudang.name : '-' }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Kode</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ pembelian.code }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Grade</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ pembelian.grade ? pembelian.grade.name : '-' }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Berat (kg)</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ formatNumber(pembelian.bobot) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Status</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ pembelian.pembayaran_supplier ? 'Terbayar' : 'Pending' }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column text-danger">
                                <div :class="isPembayaran ? 'form-check' : ''">
                                    <input v-if="isPembayaran" class="form-check-input" type="checkbox" v-model="pembayaran.pengurang_status">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Pengurang (-)
                                    </label>
                                </div>
                            </th>
                            <td class="fit-column">:</td>
                            <td v-if="isPembayaran" class="text-danger">
                                <div class="input-group" v-show="pembayaran.pengurang_status">
                                    <input v-validate="'min_value:0|max_value:100'" min="0" max="100" v-model="pembayaran.pengurang" type="number" name="pengurang" class="form-control">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon1">%</span>
                                    </div>
                                </div>
                                <span class="text-danger">{{ errors.first('pengurang') }}</span>
                            </td>
                            <th v-else class="text-danger">{{ pembayaran && pembayaran.pengurang_status && pembayaran.pengurang ? formatNumber(pembayaran.pengurang) + '%' : '-' }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column text-danger">
                                <div :class="isPembayaran ? 'form-check' : ''">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Berat akhir (-)
                                    </label>
                                </div>
                            </th>
                            <td class="fit-column">:</td>
                            <th v-if="isPembayaran" class="text-danger">
                                {{ formatNumber(beratAkhir) }}
                            </th>
                            <th v-else class="text-danger">{{ pembayaran && pembayaran.berat_akhir ? formatNumber(pembayaran.berat_akhir) : formatNumber(beratAkhir) }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Harga per kg</th>
                            <td class="fit-column">:</td>
                            <td v-if="isPembayaran" class="text-primary">
                                <input v-validate="'required|min_value:0'" min="0" v-model="pembayaran.harga_per_kg" type="number" name="harga_per_kg" class="form-control">
                                <span class="text-danger">{{ errors.first('harga_per_kg') }}</span>
                            </td>
                            <th v-else class="text-primary">{{ pembayaran ? formatNumber(pembayaran.harga_per_kg) : '-' }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column text-info">
                                <div :class="isPembayaran ? 'form-check' : ''">
                                    <input v-if="isPembayaran" class="form-check-input" type="checkbox" v-model="pembayaran.pajak_status">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Pajak (-)
                                    </label>
                                </div>
                            </th>
                            <td class="fit-column">:</td>
                            <td v-if="isPembayaran" class="text-info">
                                <div class="input-group" v-show="pembayaran.pajak_status">
                                    <input v-validate="'min_value:0|max_value:100'" min="0" max="100" v-model="pembayaran.pajak" type="number" name="pajak" class="form-control">
                                    <div class="input-group-append">
                                        <span class="input-group-text" id="basic-addon1">%</span>
                                    </div>
                                </div>
                                <span class="text-danger">{{ errors.first('pajak') }}</span>
                            </td>
                            <th v-else class="text-info">{{ pembayaran && pembayaran.pajak_status && pembayaran.pajak ? formatNumber(pembayaran.pajak) + '%' : '-' }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column text-info">
                                <div :class="isPembayaran ? 'form-check' : ''">
                                    <input v-if="isPembayaran" class="form-check-input" type="checkbox" v-model="pembayaran.admin_status">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Admin (-)
                                    </label>
                                </div>
                            </th>
                            <td class="fit-column">:</td>
                            <td v-if="isPembayaran" class="text-info">
                                <input v-show="pembayaran.admin_status" v-validate="'min_value:0'" min="0" v-model="pembayaran.admin" type="number" name="admin" class="form-control">
                                <span class="text-danger">{{ errors.first('admin') }}</span>
                            </td>
                            <th v-else class="text-info">{{ pembayaran && pembayaran.admin_status ? formatNumber(pembayaran.admin) : '-' }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column text-info">
                                <div :class="isPembayaran ? 'form-check' : ''">
                                    <input v-if="isPembayaran" class="form-check-input" type="checkbox" v-model="pembayaran.potongan_status">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Potongan (-)
                                    </label>
                                </div>
                            </th>
                            <td class="fit-column">:</td>
                            <td v-if="isPembayaran" class="text-info">
                                <input v-show="pembayaran.potongan_status" v-model="pembayaran.potongan_notes" type="text" placeholder="Keterangan" name="potongan_notes" class="form-control">
                            </td>
                            <th v-else class="text-info">{{ pembayaran && pembayaran.potongan_status ? (pembayaran.potongan_notes || formatNumber(pembayaran.potongan)) : '-' }}</th>
                        </tr>
                        <tr v-show="(pembayaran && pembayaran.potongan_notes) || (isPembayaran && pembayaran && pembayaran.potongan_status)">
                            <th></th>
                            <td></td>
                            <td v-if="isPembayaran" class="text-info">
                                <input v-show="pembayaran.potongan_status" v-validate="'min_value:0'" min="0" v-model="pembayaran.potongan" type="number" name="bonus" class="form-control">
                                <span class="text-danger">{{ errors.first('bonus') }}</span>
                            </td>
                            <th v-else class="text-info">{{ pembayaran && pembayaran.potongan_status ? formatNumber(pembayaran.potongan) : '-' }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column text-warning">
                                <div :class="isPembayaran ? 'form-check' : ''">
                                    <input v-if="isPembayaran" class="form-check-input" type="checkbox" v-model="pembayaran.tambahan_biaya_status">
                                    <label class="form-check-label" for="defaultCheck1">
                                        Bonus (+)
                                    </label>
                                </div>
                            </th>
                            <td class="fit-column">:</td>
                            <td v-if="isPembayaran" class="text-warning">
                                <input v-show="pembayaran.tambahan_biaya_status" v-model="pembayaran.tambahan_biaya_notes" type="text" placeholder="Keterangan" name="tambahan_biaya_notes" class="form-control">
                            </td>
                            <th v-else class="text-warning">{{ pembayaran && pembayaran.tambahan_biaya_status ? (pembayaran.tambahan_biaya_notes || formatNumber(pembayaran.tambahan_biaya)) : '-' }}</th>
                        </tr>
                        <tr v-show="(pembayaran && pembayaran.tambahan_biaya_notes) || (isPembayaran && pembayaran && pembayaran.tambahan_biaya_status)">
                            <th></th>
                            <td></td>
                            <td v-if="isPembayaran" class="text-warning">
                                <input v-show="pembayaran.tambahan_biaya_status" v-validate="'min_value:0'" min="0" v-model="pembayaran.tambahan_biaya" type="number" name="bonus" class="form-control">
                                <span class="text-danger">{{ errors.first('bonus') }}</span>
                            </td>
                            <th v-else class="text-warning">{{ pembayaran && pembayaran.tambahan_biaya_status ? formatNumber(pembayaran.tambahan_biaya) : '-' }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">GRAND TOTAL</th>
                            <td class="fit-column">:</td>
                            <th class="text-primary">{{ pembayaran ? formatNumber(totalPembayaran) : '-' }}</th>
                        </tr>
                        <tr>
                            <th class="fit-column">Metode</th>
                            <td class="fit-column">:</td>
                            <td v-if="isPembayaran">
                                <div class="input-group single mb-0 d-flex">
                                    <multiselect class='w-auto flex-grow-1' v-validate="'required'" name="metode" v-model="metode" :options="metodeOptions" :placeholder="'Pilih'" :searchable="true"
                                        label="value" track-by="name" :allowEmpty="false" :show-labels="false"></multiselect>
                                </div>
                                <span class="text-danger">{{ errors.first('metode') }}</span>
                            </td>
                            <th v-else class="text-primary">{{ pembayaran ? pembayaran.metode : '-' }}</th>
                        </tr>
                    </table>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="koreksi" type="button" class="btn btn-secondary">Koreksi</button>
                <button :disabled="isLoading" v-if="isKonfirmasi" @click="save" type="button" class="btn btn-primary mr-2">OK</button>
                <button :disabled="isLoading" v-if="!isKonfirmasi" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                <button :disabled="isLoading" v-if="!isPembayaran" @click="print" type="button" class="btn btn-primary mr-2"><i class="fas fa-print"></i> Print</button>
                <button :disabled="isLoading" v-if="isPembayaran && !isKonfirmasi" @click="konfirmasi" type="button" class="btn btn-primary mr-2">Bayar</button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    name: "pembelian-viewer",

    props: {
        isPembayaran: {
            type: Boolean,
            default: false,
        },

        value: {
            type: Object,
            default: () => {},
        }
    },

    components: {
        Multiselect,
    },

    data() {
        return {
            pembelian: null,
            pembayaran: null,
            metode: null,
            metodeOptions: [
                {
                    name: 'tunai',
                    value: 'Tunai',
                },
                {
                    name: 'transfer',
                    value: 'Transfer',
                },
            ],
            isKonfirmasi: false,
        }
    },

    created() {
    },

    mounted() {
        if (this.value) {
            this.initPembayaran();
        }
    },

    computed: {
        beratAkhir() {
            let bobot = parseInt(this.pembelian.bobot);
            let pengurang = this.pembayaran.pengurang_status && this.pembayaran.pengurang ? parseInt(Math.ceil(bobot * this.pembayaran.pengurang / 100)) : 0;
            return bobot - pengurang;
        },

        totalPembayaran() {
            let harga = parseInt(this.pembayaran.harga_per_kg);
            let beratAkhir = this.beratAkhir;
            let totalHarga = harga * beratAkhir;
            let pajak = this.pembayaran.pajak_status && this.pembayaran.pajak ? parseInt(Math.floor(totalHarga * this.pembayaran.pajak / 100)) : 0;
            let admin = this.pembayaran.admin_status && this.pembayaran.admin ? parseInt(this.pembayaran.admin) : 0;
            let potongan = this.pembayaran.potongan_status && this.pembayaran.potongan ? parseInt(this.pembayaran.potongan) : 0;
            let tambahanBiaya = this.pembayaran.tambahan_biaya_status && this.pembayaran.tambahan_biaya ? parseInt(this.pembayaran.tambahan_biaya) : 0;
            return totalHarga - pajak - admin - potongan + tambahanBiaya;
        },
    },

    watch: {
        value() {
            this.initPembayaran();
        }
    },

    methods: {
        initPembayaran() {
            let self = this;

            self.pembelian = Object.assign({}, self.value);
            self.pembayaran = Object.assign({}, self.pembelian.pembayaran_supplier || {
                pengurang: 10,
                pengurang_status: false,
                berat_akhir: Math.floor(self.pembelian.bobot - (self.pembelian.bobot * 10 / 100)),
                harga_per_kg: null,
                pajak: 0.5,
                pajak_status: false,
                admin: 10000,
                admin_status: false,
                potongan: null,
                potongan_notes: null,
                potongan_status: false,
                tambahan_biaya: null,
                tambahan_biaya_notes: null,
                tambahan_biaya_status: false,
            });
            let metodeIndex = self.metodeOptions.findIndex(option => option.name == self.pembayaran.metode);
            self.metode = Object.assign({}, self.metodeOptions[metodeIndex]);
        },

        print() {
            let self = this;

            self.isLoading = true;
            self.$Progress.start();
            var newIframe = document.createElement('iframe');
            newIframe.width = '0';
            newIframe.height = '0';
            newIframe.src = '/pembayaran-suppliers/print/'+self.pembelian.id;
            document.body.appendChild(newIframe);
            newIframe.focus();
            newIframe.onload = function () {
                self.isLoading = false;
                self.$Progress.finish();
                newIframe.contentWindow.print();
                self.$emit('cancel');
            }
        },

        koreksi() {
            this.isKonfirmasi = false;
        },

        konfirmasi() {
            let self = this;

            self.$validator.validateAll().then(result => {
                if (result) {
                    self.isKonfirmasi = true;
                }
            });
        },

        save() {
            let self = this,
                data = Object.assign({}, {
                    harga_per_kg: self.pembayaran.harga_per_kg,
                    metode: self.metode.name,
                    pengurang: self.pembayaran.pengurang,
                    pengurang_status: self.pembayaran.pengurang_status,
                    berat_akhir: self.beratAkhir,
                    pajak: self.pembayaran.pajak,
                    pajak_status: self.pembayaran.pajak_status,
                    admin: self.pembayaran.admin,
                    admin_status: self.pembayaran.admin_status,
                    potongan: self.pembayaran.potongan,
                    potongan_notes: self.pembayaran.potongan_notes,
                    potongan_status: self.pembayaran.potongan_status,
                    tambahan_biaya: self.pembayaran.tambahan_biaya,
                    tambahan_biaya_notes: self.pembayaran.tambahan_biaya_notes,
                    tambahan_biaya_status: self.pembayaran.tambahan_biaya_status,
                });

            self.isLoading = true;
            let api = '/api/pembayaran-suppliers/pembayaran/'+self.pembelian.id;

            self.$Progress.start();
            axios({
                method: 'post',
                url: api,
                data: data
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.isLoading = false;
                self.$Progress.finish();
                self.$emit('saved', response.data.data);
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },
    },
}
</script>
<style>
.fit-column {
    width: 0.1%;
    white-space: nowrap;
}

th, td {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
</style>
